import { render, staticRenderFns } from "./VideoGallerySingle.vue?vue&type=template&id=30931aaa&scoped=true"
import script from "./VideoGallerySingle.vue?vue&type=script&lang=js"
export * from "./VideoGallerySingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30931aaa",
  null
  
)

export default component.exports